export const MINUTE = 'minute';
export const HOUR = 'hour';
export const DAY = 'day';
export const WEEK = 'week';
export const FOUR_WEEK = 'fourWeek';
export const LAST_30_DAYS_HOUR = 'hour';
